module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAX0lEQVR4AWOgC4ho3B3etCeu42BYw24gGw+Caghr2pPXuHl92YSY5j3hxGiI7zy4vbDzs7X17KYl4W0Hwgnb0LgnrWn74to5Yc37iLIBRZQmGn5eEyMSDUIbSNcwKAEAE6P8m5cwWVMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AW.png
// module id = 1081
// module chunks = 0